var isOtpSmsSendingLocked = false;
var isOtpEmailSendingLocked = false;
var pageReloadTimer;

$(function () {
  initValidation();
  initEvents();

  $(".codeMask").inputmask({ alias: "integer", rightAlign: false });
});

function initEvents() {
  $('#LoginEmailAddress').keydown(function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();

      $("#submitEmailBttn").trigger("click");
    }
  });

  $('#LoginPassword').keydown(function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();

      $("#LoginForm").submit();
    }
  });

  $('#OneTimePassword').keydown(function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();

      $("#LoginForm").submit();
    }
  });

  $("#submitEmailBttn").click(function (e) {
    e.preventDefault();

    if ($("#LoginForm").valid()) {
      $('.emailDiv').hide();
      $('#LoginEmailAddress').prop('readonly', true).addClass('disabled').attr('disabled', 'disabled');
      $('#EmailAddress').val($('#LoginEmailAddress').val());

      var data = { emailAddress: $("#LoginEmailAddress").val() };
      postAsJson('/api/Home/CheckSmsLoginSupported', JSON.stringify(data), function (result) {
        if (result.isSmsLoginSupported) {
          $('.requestSmsOtpBttn').show();
        }

        $('.loginChoiceDiv').show();
      });      
    }
  });

  $(".changeLoginType").click(function (e) {
    e.preventDefault();
    $('.passwordDiv').hide();
    $('.smsOtpEntry').hide();
    $('.emailOtpEntry').hide();
    $('.loginChoiceDiv').show();
  });

  $("#loginWithPasswordBttn").click(function (e) {
    $('.loginChoiceDiv').hide();

    $('.passwordDiv').show();
    $('#LoginPassword').focus();
  });

  $('.requestSmsOtpBttn,.resendSmsOtpBttn').click(function (e) {
    e.preventDefault();
    $('.loginChoiceDiv').hide();

    if (!isOtpSmsSendingLocked) {
      var data = { emailAddress: $("#LoginEmailAddress").val() };

      $.ajax({
        url: '/api/Home/SmsOneTimePassword',
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(data),
        headers: {
          RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
          startPageReloadTimer();

          $('.smsOtpEntry').show();
          $('.smsOtpEntryMessage').text(result.otpEntryMessage);

          $('.requestSmsOtpBttn,.resendSmsOtpBttn').addClass('disabled').attr('disabled', 'disabled');

          $('#OneTimePasswordSms').focus();

          isOtpSmsSendingLocked = true;

          //rate-limit sending to every 30 seconds
          setTimeout(function () {
            $('.requestSmsOtpBttn,.resendSmsOtpBttn').removeClass('disabled').removeAttr('disabled');
            isOtpSmsSendingLocked = false;
          }, 30000);
        }
      });
    }
  });

  $('.requestEmailOtpBttn,.resendEmailOtpBttn').click(function (e) {
    e.preventDefault();
    $('.loginChoiceDiv').hide();

    if (!isOtpEmailSendingLocked) {
      var data = { emailAddress: $("#LoginEmailAddress").val() };

      $.ajax({
        url: '/api/Home/EmailOneTimePassword',
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(data),
        headers: {
          RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
          startPageReloadTimer();

          $('.emailOtpEntry').show();
          $('.emailOtpEntryMessage').text(result.otpEntryMessage);

          $('.requestEmailOtpBttn,.resendEmailOtpBttn').addClass('disabled').attr('disabled', 'disabled');

          $('#OneTimePasswordEmail').focus();

          isOtpEmailSendingLocked = true;

          //rate-limit sending to every 30 seconds
          setTimeout(function () {
            $('.requestEmailOtpBttn,.resendEmailOtpBttn').removeClass('disabled').removeAttr('disabled');
            isOtpEmailSendingLocked = false;
          }, 30000);
        }
      });
    }
  });

  $("#changeEmailBttn").click(function (e) {
    e.preventDefault();
    location.reload();
  });

  $(".loginBttn").click(function (e) {
    $("#LoginForm").submit();
  });

  $("#forgotPasswordSend").click(function (e) {
    $("#ForgotPasswordForm").submit();
  });

  $('#showForgotPasswordModal').click(function () {
    $('#ForgotPasswordForm #ForgotEmail').val($('#EmailAddress').val());
    $('#ForgotPasswordModal').modal('show');
  });

  $('#ForgotPasswordModal').on('hidden.bs.modal', function (e) {
    $('#ForgotPasswordForm #ForgotEmail').val('');
    $('#forgotPasswordSend').removeClass('disabled');
  })
}

function startPageReloadTimer() {
  if (pageReloadTimer) {
    clearTimeout(pageReloadTimer);
  }

  pageReloadTimer = setTimeout(function () {
    location.reload();
  }, 600000); //10 mins
}

function initValidation() {
  $("#LoginForm").validate(
    {
      submitHandler: function (form) {
        form.submit();
      },
      rules: {
        LoginEmailAddress: {
          required: true,
          email: true,
        },
        Password: {
          required: true
        },
        OneTimePassword: {
          required: true
        }
      },
      messages: {
        LoginEmailAddress: {
          required: "Email is required.",
          email: "Email must be a valid email address."
        },
        Password: {
          required: "Password is required."
        },
        OneTimePassword: {
          required: "One-Time Login Code is required."
        }
      },
      errorContainer: '#errorMessageBox',
      errorLabelContainer: '#errorList',
      errorElement: "li",
      onkeyup: false
    });

  $("#ForgotPasswordForm").validate({
    submitHandler: function (form) {
      $('#forgotPasswordSend').addClass('disabled');
      var json = { emailAddress: $("#ForgotEmail").val() };

      postAsJson('/api/Home/ForgotPassword', JSON.stringify(json), function () {
        $('<div class="alert alert-success"><button type="button" class="close" data-dismiss="alert">&times;</button><h4>Forgot Password Email Sent</h4><p>If the email address entered exists in the system, a password reset email has been sent.</p></div>').appendTo('#alertContainer');
        $("#ForgotPasswordModal").modal('hide');
      });
    },
    rules: {
      ForgotEmail: {
        required: true,
        email: true
      }
    },
    messages: {
      ForgotEmail: {
        required: 'Email address is required.',
        email: 'Email address is not valid.'
      }
    },
    errorContainer: '#forgotPasswordErrorMessageBox',
    errorLabelContainer: '#forgotPasswordErrorList',
    errorElement: "li",
    onkeyup: false
  });
}
